import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Login
  },
  {
    path: '/main',
    name: 'Main',
    redirect: 'HomePage',
    component: () => import('../views/Main'),
    children: [
      // 全局搜索页 ===================
      {
        path: '/homepagemain', name: 'HomePageMain', component: () => import('@/views/HomePage/indexmain.vue'),
        meta: {
          keepAlive: false,
          title: "全局搜索"
        }
      },
      // 首页 开始 ===================
      {
        path: '/homepage', name: 'HomePage', component: () => import('@/views/HomePage'),
        meta: {
          keepAlive: false,
          title: ""
        }
      },
      {
        path: '/list', name: 'List', component: () => import('@/views/List'),
        meta: {
          keepAlive: false,
          title: "列表信息"
        }
      },
      //  ========= 分享
      {
        path: '/meshare', name: 'MeShare', component: () => import('@/views/Share/meshare.vue'),
        meta: {
          keepAlive: false,
          title: "查看分享"
        },
      },
      //  ========= 我的
      {
        path: '/mecollect', name: 'Me', component: () => import('@/views/Me'),
        meta: {
          keepAlive: false,
          title: "我的收藏"
        },
      },

      //  ========= 对外分享页面
      {
        path: '/out', name: 'Out', component: () => import('@/views/Zout'),
        meta: {
          keepAlive: false,
          title: "对外分享"
        },
      }
    ]
  }
]

// 避免冗余路由
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  routes
})

export default router
